import Spinner from "components/Spinner";

const Loader = ({ text, ...props }) => {
  return (
    <div className="d-flex justify-content-center align-items-center loader-outer">
      <Spinner animation="border" role="status" {...props}>
        <span className="sr-only">{text || "Loading..."}</span>
      </Spinner>
    </div>
  );
}

export default Loader;